import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Modal, FooterButton } from 'Core/components';
import CustomPropTypes from 'Core/prop-types';
import { addQualityAlert, fetchQualityAlertByPartId } from './store/slice';
import { AppModal } from '../components/app-modals';
import QualityAlertAddEditForm from './quality-alert-add-edit-form';
import { selectQualityAlertLoading, selectQualityAlertsData } from './store/selectors';
import { showToast } from '../../core/redux/toast/slice';

const requiredFields = ['title', 'description', 'files'];

const QualityAlertAddEdit = ({ showModal, modalData, onCloseModal }) => {
  const [formData, setFormData] = useState(null);
  const [tempFiles, setTempFile] = useState([]);
  const [formRef, setFormRef] = useState(null);
  const [invalidFields, setInvalidFields] = useState([]);
  const [showValidation, setShowValidation] = useState(false);

  const dispatch = useDispatch();
  const qualityAlertData = useSelector(selectQualityAlertsData);
  let isEditMode = Boolean(qualityAlertData?.id);
  const isLoading = useSelector(selectQualityAlertLoading);

  useEffect(() => {
    if (modalData?.id) {
      dispatch(fetchQualityAlertByPartId(modalData.id));
    }
  }, [dispatch, modalData?.id]);

  const onFileUpload = (documentName, file) => {
    if (file) {
      setTempFile(prevFiles => {
        const updatedFiles = prevFiles.map(f =>
          f.documentName === documentName ? { ...f, file } : f,
        );

        // If documentName exists, update it; otherwise, add new file
        const isExisting = prevFiles.some(f => f.documentName === documentName);

        return isExisting ? updatedFiles : [...prevFiles, { file, documentName }];
      });
    }
  };

  const onChangesForm = data => {
    setFormData(data);
  };

  const handleClose = () => {
    onCloseModal();
  };

  const body = () => {
    return (
      <QualityAlertAddEditForm
        data={qualityAlertData}
        partId={modalData?.id}
        onChanges={onChangesForm}
        onFileUpload={onFileUpload}
        isEditMode={isEditMode}
        formRef={setFormRef}
        invalidFields={invalidFields}
        showValidation={showValidation}
        setInvalidFields={setInvalidFields}
      />
    );
  };

  const valid = () => {
    const missingFields = requiredFields.filter(field => {
      const value = formData?.[field];
      return (
        !value || (Array.isArray(value) && value.length === 0) || value.toString().trim() === ''
      );
    });

    setInvalidFields(missingFields);
    setShowValidation(true);

    if (missingFields.length > 0) {
      dispatch(
        showToast({
          message: `Please fill all required fields: ${missingFields.join(', ')}`,
          type: 'danger',
        }),
      );

      setTimeout(() => {
        if (formRef && formRef.current) {
          formRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }, 100);

      return false;
    }

    return true;
  };

  // const footer = () => {
  //   const onSave = async () => {
  //     if (!valid(formData)) return;

  //     dispatch(addQualityAlert(formData));
  //   };

  // const footer = () => {
  //   const onSave = async () => {
  //     if (!valid()) return;

  //     const payload = { ...formData };

  //     // Strip HTML from description
  //     const stripHtml = html => {
  //       const div = document.createElement('div');
  //       div.innerHTML = html;
  //       return div.textContent || div.innerText || '';
  //     };

  //     if (payload.description) {
  //       payload.description = stripHtml(payload.description);
  //     }

  //     // Fill in default values for required API fields if missing
  //     const requiredDefaults = {
  //       status: 'Active',
  //       isDeleted: 'false',
  //       dateTime: new Date().toISOString(),
  //       userId: localStorage.getItem('UserId'),
  //       processId: '',
  //       partId: modalData.id,
  //     };

  //     Object.entries(requiredDefaults).forEach(([key, defaultValue]) => {
  //       if (!payload[key]) {
  //         payload[key] = defaultValue;
  //       }
  //     });

  //     dispatch(addQualityAlert(payload));
  //   };

  //   // return (
  //   //   <div className="row">
  //   //     <div className="col-lg-8"></div>
  //   //     <div className="col-lg-4">
  //   //       <FooterButton
  //   //         cancelText="Cancel"
  //   //         saveText="Save "
  //   //         onSave={onSave}
  //   //         onCancel={handleClose}
  //   //         //disableSave={isEditMode}
  //   //       />
  //   //     </div>
  //   //   </div>
  //   // );
  // };

  return (
    <Modal
      id="quality-alert-modal"
      show={showModal}
      size="xl"
      title={isEditMode ? 'View QualityAlert' : 'Add QualityAlert'}
      body={body}
      handleClose={handleClose}
    />
  );
};

QualityAlertAddEdit.propTypes = {
  showModal: PropTypes.bool,
  modalData: PropTypes.shape(CustomPropTypes.QualityAlert),
  onCloseModal: PropTypes.func,
};

export default AppModal(QualityAlertAddEdit);
